import gql from 'graphql-tag';

import client from '../graphqlAPI';

/*
The slugs of every post in the tours category, as a Set.

A ticket knows which posts it appears on (postSlugNames, resolved through the
events join) but not what kind of post those are. This is the other half: the
manager asks once which posts are tours, then any ticket can be classified
without a further round trip.

Cached for the lifetime of the page — the tours category gains a post every few
weeks, and a stale entry only costs a missing advisory line.
*/
const GET_TOUR_POST_SLUGS = gql`
  query getPostsByCategory($category: String!) {
    getPostsByCategory(category: $category) {
      posts {
        slugName
      }
    }
  }
`;

let cached = null;

const getTourPostSlugs = async () => {
  if (cached) return cached;

  try {
    const result = await client
      .query({
        query: GET_TOUR_POST_SLUGS,
        variables: { category: 'tours' },
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
      })
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const posts = (result && result.data && result.data.getPostsByCategory && result.data.getPostsByCategory.posts) || [];
    const slugs = new Set(posts.map(post => post && post.slugName).filter(Boolean));

    // An empty answer is not cached: a failed or unauthenticated call would
    // otherwise silence the advisory for the rest of the session.
    if (slugs.size) cached = slugs;
    return slugs;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getTourPostSlugs Error: ${error}`);
    return new Set();
  }
};

export default getTourPostSlugs;
